import { api } from '../api';
import { showGoodToast, showBadToast } from '../../errors/toast';
import { IngredientRecipe, IngredientProduction } from '../../../models/Recept';

const actions = {
    // DateTime from, DateTime until
    async loadIngredientProductionInfo(context, data) {
        let tempList = [];
        try {
            const res = await api.fetchIngredientProductionInfo(data.data);
            tempList = res.data.Items.map((x) => new IngredientProduction(x));
        } catch (error) {
            tempList = [];
            showBadToast(
                context,
                data.func('com_errorladen', {
                    ns: 'common',
                    val: data
                        .func('com_production', { ns: 'common' })
                        .toLowerCase()
                }),
                error
            );
        }
        context.commit('insertIngredientProductionLijst', tempList);
        return tempList;
    },

    // ingredientProductionID
    async loadIngredientProduction(context, data) {
        let item = null;
        try {
            const res = await api.fetchIngredientProduction(data.data);
            item = new IngredientProduction(res.data);
        } catch (error) {
            item = null;
            showBadToast(
                context,
                data.func('com_errorladen', {
                    ns: 'common',
                    val: data
                        .func('com_production', { ns: 'common' })
                        .toLowerCase()
                }),
                error
            );
        }
        return item;
    },
    //  DeleteObjectModel dom {id, LastUpdated}
    async deleteProduction(context, data) {
        try {
            await api.deleteIngredientProduction(data.data);
            showGoodToast(
                context,
                data.func('com_verwijderd', {
                    ns: 'common',
                    val: data.func('com_production', { ns: 'common' })
                })
            );
        } catch (error) {
            showBadToast(
                context,
                data.func('com_errorverwijder', {
                    ns: 'common',
                    val: data.func('com_production', { ns: 'common' })
                }),
                error
            );
        }
    },
    async loadProductionRecipeInfo(context, data) {
        let tempList = [];
        try {
            const res = await api.fetchProductionRecipeInfo(data.data);
            tempList = res.data.Items.map((x) => new IngredientRecipe(x));
        } catch (error) {
            tempList = [];
            showBadToast(
                context,
                data.func('com_errorladen', {
                    ns: 'common',
                    val: data
                        .func('com_recipes', { ns: 'common' })
                        .toLowerCase()
                }),
                error
            );
        }
        context.commit('insertProductionRecipeInfoLijst', tempList);
        return tempList;
    },
    // recipeID
    async loadProductionRecipe(context, data) {
        let item = null;
        try {
            const res = await api.fetchProductionRecipe(data.data);
            item = new IngredientRecipe(res.data);
        } catch (error) {
            item = null;
            showBadToast(
                context,
                data.func('com_errorladen', {
                    ns: 'common',
                    val: data.func('com_recipe', { ns: 'common' }).toLowerCase()
                }),
                error
            );
        }
        return item;
    },

    async saveProductionRecipe(context, data) {
        try {
            await api.storeProductionRecipe(data.data);
            showGoodToast(
                context,
                data.func('com_opgeslagen', {
                    ns: 'common',
                    val: data.func('com_recipe', { ns: 'common' })
                })
            );
        } catch (error) {
            showBadToast(
                context,
                data.func('com_erroropslaan', {
                    ns: 'common',
                    val: data.func('com_recipe', { ns: 'common' }).toLowerCase()
                }),
                error
            );
        }
    },

    async saveIngredientProduction(context, data) {
        try {
            await api.storeIngredientProduction(data.data);
            showGoodToast(
                context,
                data.func('com_opgeslagen', {
                    ns: 'common',
                    val: data.func('prod_stockitem', { ns: 'production' })
                })
            );
        } catch (error) {
            showBadToast(
                context,
                data.func('com_erroropslaan', {
                    ns: 'common',
                    val: data
                        .func('prod_stockitem', { ns: 'production' })
                        .toLowerCase()
                }),
                error
            );
        }
    },

    async deleteRecipe(context, data) {
        try {
            await api.closeProductionRecipe(data.data);
            context.commit('deleteProductionRecipe', data.data);
            showGoodToast(
                context,
                data.func('com_verwijderd', {
                    ns: 'common',
                    val: data.func('com_recipe', { ns: 'common' })
                })
            );
        } catch (error) {
            showBadToast(
                context,
                data.func('com_errorverwijder', {
                    ns: 'common',
                    val: data.func('com_recipe', { ns: 'common' })
                }),
                error
            );
        }
    }
};

export default actions;
